import { Injectable, inject } from '@angular/core';
import { User } from '@data/user/user.model';
import { UserQuery } from '@data/user/user.query';

/** Used this to check user info filled out in the user profile.. Maybe could be somewhere else or other implementation, will see:) */
@Injectable({
  providedIn: 'root',
})
export class UserFormService {
  private userQuery = inject(UserQuery);

  userData: User | undefined;

  constructor() {
    this.userQuery.selectUser$.subscribe((user) => {
      this.userData = user;
    });
  }

  isUserInfoValid(): boolean {
    return !!this.userData && this.isUserNameFilledOut() && this.isInstitutionAdded();
  }

  private isUserNameFilledOut(): boolean {
    return !!this.userData?.name && !!this.userData?.lastName;
  }

  private isInstitutionAdded(): boolean {
    return !!this.userData?.institutionId;
  }
}
